import classNames from 'classnames';
import React from 'react';

import {CurriculumSummary} from '@udemy/career-academies';
import {useI18n} from '@udemy/i18n';

import styles from './academies-steps.module.less';
import {AcademiesSteps} from './academies-steps.react-component';

interface AcademiesStepWrapperProps {
    slug: string;
    summariesOrder: string[];
    summariesContent: Record<string, CurriculumSummary>;
}

export const AcademiesStepWrapper = ({
    slug,
    summariesOrder,
    summariesContent,
}: AcademiesStepWrapperProps): JSX.Element | null => {
    const {gettext} = useI18n();
    const summaries = summariesOrder.map((id) => ({
        id,
        ...summariesContent[id],
    }));

    if (summaries.length === 0) {
        return null;
    }

    return (
        <div className={classNames(styles['steps-container'], 'ud-container')}>
            <h2 className={styles['section-title']}>{gettext("What you'll learn")}</h2>
            <div className={styles.wrapper}>
                {summaries.map((summary, idx) => (
                    <AcademiesSteps
                        key={`${summary.id}-${idx}`}
                        id={summary.id}
                        number={idx + 1}
                        slug={slug}
                        title={summary.title}
                        description={summary.description}
                        curriculumId={`curriculum-${summary.id}`}
                    />
                ))}
            </div>
        </div>
    );
};
